var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22922 6.22922C6.53485 5.92359 7.03037 5.92359 7.336 6.22922L12 10.8932L16.664 6.22922C16.9696 5.92359 17.4652 5.92359 17.7708 6.22922C18.0764 6.53485 18.0764 7.03037 17.7708 7.336L13.1068 12L17.7708 16.664C18.0764 16.9696 18.0764 17.4652 17.7708 17.7708C17.4652 18.0764 16.9696 18.0764 16.664 17.7708L12 13.1068L7.336 17.7708C7.03037 18.0764 6.53485 18.0764 6.22922 17.7708C5.92359 17.4652 5.92359 16.9696 6.22922 16.664L10.8932 12L6.22922 7.336C5.92359 7.03037 5.92359 6.53485 6.22922 6.22922Z",
    fill: "#363736"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.42c52204e84da75d1489229fb3aa63df.svg";
export { ForwardRef as ReactComponent };